export default "__VITE_ASSET__BsE0NFuy__"